;
define("cart_detailed.tpl", function(){});

